"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFrameComponent = _interopRequireDefault(require("react-frame-component"));

var _Button = _interopRequireDefault(require("./Button"));

var _tablet = _interopRequireDefault(require("../assets/tablet.svg"));

var _mobile = _interopRequireDefault(require("../assets/mobile.svg"));

var _rotate = _interopRequireDefault(require("../assets/rotate.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialContent = "\n<!DOCTYPE html>\n<html>\n  <head></head>\n  <body>\n    <div class=\"mount\"></div>\n  </body>\n</html>\n";
var MOBILE = 'mobile';
var TAB = 'tab';

var checkType = function checkType(type) {
  if (type === MOBILE || type === TAB) {
    return type;
  }
};

var Emulator = /*#__PURE__*/function (_Component) {
  _inherits(Emulator, _Component);

  var _super = _createSuper(Emulator);

  function Emulator() {
    var _this;

    _classCallCheck(this, Emulator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      withoutChrome: _this.props.withoutChrome,
      type: checkType(_this.props.type) || MOBILE,
      rotate: false
    });

    _defineProperty(_assertThisInitialized(_this), "buttonProps", [{
      imageClass: '',
      name: MOBILE,
      icon: _mobile["default"],
      handleClick: function handleClick() {
        return _this.handleSwitch(MOBILE);
      }
    }, {
      imageClass: '',
      name: TAB,
      icon: _tablet["default"],
      handleClick: function handleClick() {
        return _this.handleSwitch(TAB);
      }
    }]);

    _defineProperty(_assertThisInitialized(_this), "setChromeClassName", function () {
      var _this$state = _this.state,
          type = _this$state.type,
          rotate = _this$state.rotate;
      var withoutChromeClass = _this.state.withoutChrome ? 'without-chrome' : '';
      var rotateChromeClass = _this.rotateChrome(rotate, type) || '';
      return "".concat(type, "-chrome ").concat(withoutChromeClass, " ").concat(rotateChromeClass);
    });

    _defineProperty(_assertThisInitialized(_this), "setFrameClassName", function () {
      var type = _this.state.type;
      var rotateFrameClass = _this.rotateFrame(type, _this.state.rotate) || '';
      return "".concat(type, "-frame ").concat(rotateFrameClass);
    });

    _defineProperty(_assertThisInitialized(_this), "rotateChrome", function (rotate, type) {
      if (rotate) {
        return _this.state.withoutChrome ? "chrome-rotate ".concat(type, "-reposition--without-chrome") : "chrome-rotate ".concat(type, "-reposition");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "rotateFrame", function (type, rotate) {
      if (rotate) {
        return "".concat(type, "-frame-rotate");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderFrameComponent", function (_ref) {
      var children = _ref.children;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _this.setChromeClassName()
      }, /*#__PURE__*/_react["default"].createElement(_reactFrameComponent["default"], {
        className: "frame ".concat(_this.setFrameClassName()),
        initialContent: initialContent
      }, children));
    });

    _defineProperty(_assertThisInitialized(_this), "renderIFrame", function (_ref2) {
      var url = _ref2.url;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _this.setChromeClassName()
      }, /*#__PURE__*/_react["default"].createElement("iframe", {
        src: url,
        className: "frame ".concat(_this.setFrameClassName())
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFrames", function () {
      return !_this.props.url ? _this.renderFrameComponent(_this.props) : _this.renderIFrame(_this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSwitch", function (type) {
      _this.setState({
        type: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRotate", function () {
      _this.setState({
        rotate: !_this.state.rotate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSwitchButtons", function () {
      return _this.buttonProps.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
          key: item.name
        }, item));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderRotateButton", function () {
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        imageClass: "rotate",
        name: "rotate",
        icon: _rotate["default"],
        handleClick: _this.handleRotate
      });
    });

    return _this;
  }

  _createClass(Emulator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withDeviceSwitch = _this$props.withDeviceSwitch,
          withRotator = _this$props.withRotator;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "device-emulator-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "button-group"
      }, withDeviceSwitch && this.renderSwitchButtons(), withRotator && this.renderRotateButton()), this.renderFrames());
    }
  }]);

  return Emulator;
}(_react.Component);

_defineProperty(Emulator, "propTypes", {
  url: _propTypes["default"].string,
  children: _propTypes["default"].element,
  withoutChrome: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  withDeviceSwitch: _propTypes["default"].bool,
  withRotator: _propTypes["default"].bool
});

var _default = Emulator;
exports["default"] = _default;